interface Config {
  cognitoPool: string;
  cognitoClient: string;
  region: string;
  environment: string;
  release: string;
  sentry?: {
    dsn: string;
  };
  hes: {
    cme: string;
    cme2100: string;
  };
}

declare global {
  interface Window {
    runConfig?: Config;
  }
}

export function appConfig(): Config {
  if (window.runConfig === undefined) {
    throw new Error("No runtime config");
  }
  return window.runConfig as Config;
}

export const getApiUrl = (): string => {
  return import.meta.env?.VITE_API_URL || window.localStorage.getItem("URL");
};

export const appUrl = (): string => {
  return import.meta.env?.VITE_PUBLIC_APP_URL;
};

export const getCognitoConfig = () => {
  return {
    REGION: window.runConfig ? window.runConfig.region : "",
    USER_POOL_ID:
      import.meta.env?.VITE_COGNITO_POOL_ID ||
      (window.runConfig ? window.runConfig.cognitoPool : ""),
    APP_CLIENT_ID:
      import.meta.env?.VITE_COGNITO_CLIENT_ID ||
      (window.runConfig ? window.runConfig.cognitoClient : ""),
  };
};

export const getWebsocketBaseUrl = (): string => {
  return import.meta.env?.VITE_WEB_SOCKET_URL;
};

const config = {
  apiGateway: {
    REGION: window.runConfig ? window.runConfig.region : "",
    URL: getApiUrl(),
  },
  cognito: getCognitoConfig(),
};

export default config;
